export default __webpack_public_path__ + "static/speech-bubble-191c8742330d196b29309a9c499a2a6e.png";